/**
 * @file Core things to execute upon page load
 * This is usually code that must operate at a global scope
 * @author SASS-IT, University of Ottawa
 */
'use strict';

if (document.documentElement.lang === 'fr-CA') {
    require('jquery-ui/ui/i18n/datepicker-fr-CA');
    require('jquery-ui-timepicker-addon');
    require('jquery-ui-timepicker-addon/dist/i18n/jquery-ui-timepicker-fr');
}



// WEBPACK FOOTER //
// ./public/global/resources/js/core.js